"use client";

import { useEffect, useRef } from "react";
import { useTrackEvent } from "@/hooks/useTrackEvent";

export function VoiceAssessmentSampleTracker({
  sourcePage,
  productContext,
  resource,
}: {
  sourcePage: string;
  productContext: string;
  resource: string;
}) {
  const markerRef = useRef<HTMLSpanElement>(null);
  const trackEvent = useTrackEvent({ includeAttribution: false });

  useEffect(() => {
    const marker = markerRef.current;
    if (!marker) return;

    let hasTracked = false;
    const trackView = () => {
      if (hasTracked) return;
      hasTracked = true;
      trackEvent("voice_assessment_sample_view", {
        source_page: sourcePage,
        source_section: "voice_assessment_sample",
        product_context: productContext,
        resource,
      });
    };

    if (!("IntersectionObserver" in window)) {
      trackView();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          trackView();
          observer.disconnect();
        }
      },
      { rootMargin: "0px 0px -15%", threshold: 0.35 },
    );

    observer.observe(marker);
    return () => observer.disconnect();
  }, [productContext, resource, sourcePage, trackEvent]);

  return <span ref={markerRef} aria-hidden="true" className="pointer-events-none absolute inset-0" />;
}
